<template>
  <div class="loginbgBox">
    <div class="loginbg">
      <div class="login-body">
        <div class="left-box" @click="goIndex">
          <img
            class="logoimg"
            src="@public/static/images/setting/loginLogo.png"
            style="width: 143px"
            alt=""
          />
        </div>
        <div class="logincontent">
          <div class="header">
            <div class="line">
              <span>登录</span>
            </div>
          </div>
          <el-form
            v-if="phoneflage"
            :model="ruleForm2"
            :rules="rules"
            ref="loginform"
            autocomplete="off"
            :label-position="labelPosition"
            label-width="130px"
          >
            <el-form-item label="账号/手机号" prop="name" autocomplete="off">
              <el-input
                autocomplete="new-password"
                type="text"
                v-model="ruleForm2.name"
                placeholder="请输入账号/手机号"
                class="account"
              ></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="pass" autocomplete="new-password">
              <el-input
                autocomplete="new-password"
                :type="showPass ? 'text' : 'password'"
                v-model="ruleForm2.pass"
                placeholder="请输入密码"
                class="password"
              ></el-input>
              <img
                class="showPass"
                src="@static/images/login/icon-by.png"
                @click="showPass = !showPass"
                v-if="!showPass"
              />
              <img
                class="showPass"
                src="@static/images/login/icon-zhengyan.png"
                v-if="showPass"
                @click="showPass = !showPass"
              />
            </el-form-item>
            <el-form-item label="验证码" prop="loginCode" autocomplete="off">
              <el-input
                autocomplete="off"
                type="text"
                v-model="ruleForm2.loginCode"
                placeholder="请输入验证码"
                class="code pass-login-code"
              ></el-input>
              <img
                :src="ruleCodeImg"
                v-if="ruleCodeImg"
                alt="验证码"
                @click="getCode"
                title="点击切换验证码"
              />
            </el-form-item>
            <div class="jz clearfix">
              <!-- <div class="checkbox" @click="changeradio" :class="{ radio }">
                <span
                  ><img
                    src="@static/images/login/gou.png"
                    v-show="radio"
                    alt=""
                /></span>
                <i>记住用户名</i>
              </div> -->
              <div class="forget">
                <el-button type="text" @click="phoneOrName('loginform')"
                  >手机号验证码登录</el-button
                >
                <span @click="forget">忘记密码</span>
              </div>
              <div class="user-privacy">
                <el-checkbox v-model="isConfirm">登录即代表同意</el-checkbox
                ><span class="link" @click="link('/fxyf/agreement.html')"
                  >《用户服务协议》、</span
                ><span class="link" @click="link('/fxyf/privacy-policy.html')"
                  >《隐私政策》</span
                >
              </div>
            </div>
            <el-button
              class="loginbtn"
              @click="submitForm('loginform')"
              :loading="!shake"
              >登录</el-button
            >
          </el-form>

          <el-form
            v-else
            :model="phoneLoginForm"
            :rules="phoneLoginRules"
            ref="phoneLogin"
            autocomplete="off"
            :label-position="labelPosition"
            label-width="90px"
          >
            <el-form-item label="手机号" prop="phone" autocomplete="off">
              <!-- 避免浏览器填入信息 -->
              <el-input
                type="text"
                placeholder="请输入手机号"
                class="hide-input"
              ></el-input>
              <el-input
                type="text"
                v-model="phoneLoginForm.phone"
                placeholder="请输入手机号"
                class="phone"
                autocomplete="new-password"
              ></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="code" autocomplete="off">
              <!-- 避免浏览器填入信息 -->
              <el-input
                type="text"
                placeholder="请输入验证码"
                class="hide-input"
              ></el-input>
              <el-input
                type="text"
                v-model="phoneLoginForm.code"
                placeholder="请输入验证码"
                class="code"
              >
                <el-button
                  slot="append"
                  @click="getcode"
                  v-bind:class="getcodeflage ? 'codebtn' : 'huibtn'"
                  >{{ getcodetext }}</el-button
                >
              </el-input>
            </el-form-item>
            <div class="jz clearfix">
              <div class="forget" @click="phoneOrName('phoneLogin')">
                <el-button type="text">账号密码登录</el-button>
              </div>
            </div>
            <div class="user-privacy">
              <el-checkbox v-model="isConfirm">登录即代表同意</el-checkbox
              ><span class="link" @click="link('/fxyf/agreement.html')"
                >《用户服务协议》、</span
              ><span class="link" @click="link('/fxyf/privacy-policy.html')"
                >《隐私政策》</span
              >
            </div>
            <el-button
              class="loginbtn"
              @click="loginByphone('phoneLogin')"
              :loading="!shake"
              >登录</el-button
            >
          </el-form>
        </div>
      </div>

      <el-dialog title="" center width="800px" :visible.sync="rzerrVisible">
        <div class="rsvcontent">
          <div class="img">
            <img src="@static/images/err1.png" alt="" />
          </div>
          <div class="word">
            <p class="ti">审核未通过</p>
            <p class="desc">很遗憾的通知您，您的账号审核未通过</p>
            <p class="liyou">失败理由：{{ reason }}</p>
          </div>
        </div>
      </el-dialog>
      <el-dialog title="" center width="800px" :visible.sync="ammtVisible">
        <div class="rsvcontent">
          <div class="img">
            <img src="@static/images/wait.png" alt="" />
          </div>
          <div class="word">
            <p class="ti">审核中</p>
            <p class="desc">您好，您的账号信息正在审核中，请耐心等待</p>
          </div>
        </div>
      </el-dialog>
      <forget-pwd-dialog ref="forget"></forget-pwd-dialog>
      <app-footer></app-footer>
      <updatePwdDialog
        ref="updatePwdModal"
        @loginSuccess="loginSuccess"
      ></updatePwdDialog>
    </div>
  </div>
</template>
<script>
import footer from "@/components/footer";
import forgetPwdDialog from "@/components/forgetPwdDialog";
import updatePwdDialog from "./updatePwdDialog";
//当前实例组件
export default {
  data: () => ({
    showPass: false,
    shake: true,
    labelPosition: "top",
    // radio: true, //单选框是否选中
    errly: "", //失败理由
    rzerrVisible: false,
    ammtVisible: false,
    reason: "",
    phoneflage: true,
    ruleForm2: {
      pass: "",
      name: "",
      loginCode: "",
    },
    ruleCodeImg: "",
    ruleCodeUuid: "",
    rules: {
      name: [
        {
          required: true,
          message: "请输入账号/手机号",
          trigger: "blur",
        },
      ],
      pass: [
        {
          required: true,
          message: "请输入密码",
          trigger: "blur",
        },
      ],
      loginCode: [
        {
          required: true,
          message: "请输入验证码",
          trigger: "blur",
        },
      ],
    },
    phoneLoginRules: {
      phone: [
        {
          required: true,
          message: "请输入手机号",
          trigger: "blur",
        },
        {
          pattern: /^1[1023456789]\d{9}$/,
          message: "请输入正确的手机号",
          trigger: "blur",
        },
      ],
      code: [
        {
          required: true,
          message: "请输入验证码",
          trigger: "blur",
        },
      ],
    },
    getcodetext: "获取验证码",
    getcodeflage: true,
    phoneLoginForm: {
      phone: "",
      code: "",
    },
    resetPwdShow: false,
    isConfirm: false,
  }),
  components: {
    "app-footer": footer,
    forgetPwdDialog,
    updatePwdDialog,
  },
  created() {
    if (this.$config.env == 2) {
      this.ruleForm2.name = "小七公主";
      this.ruleForm2.pass = "Cheng123456";
    }
    this.keyupEnter();
    this.getCode();
  },
  methods: {
    goIndex() {
      location.href = "/home/index.html";
    },
    getCode() {
      let that = this;
      //账号密码登录生成验证码图片
      this.$http({
        url: "/master/user/captchaImage",
        type: "post",
        params: {
          captchaType: "math",
        },
      }).then(
        function (data) {
          if (data.httpCode == 200) {
            that.ruleCodeImg = "data:image/jpeg;base64," + data.data.img;
            that.ruleCodeUuid = data.data.uuid;
          }
        },
        function () {}
      );
    },
    //手机号登陆，账号登陆切换
    phoneOrName: function (formName) {
      this.isConfirm = false;
      this.shake = true;
      this.phoneflage = !this.phoneflage;
      // 移除表单的校验结果
      this.$refs[formName].clearValidate()
      if (formName == "phoneLogin") {
        // this.phoneLoginForm.phone = "";
        this.ruleForm2.name = this.phoneLoginForm.phone;
        this.phoneLoginForm.code = "";
      } else {
        this.phoneLoginForm.phone = "";
        this.ruleForm2.pass = "";
        this.ruleForm2.name = "";
        this.ruleForm2.code = "";
        this.getCode();
      }
    },
    keyupEnter: function () {
      //回车事件
      var that = this;
      document.onkeydown = (event) => {
        // let _key = window.event.keyCode;
        event = event ? event : window.event ? window.event : null;
        if (event.keyCode === 13) {
          if (!that.phoneflage) {
            that.loginByphone("phoneLogin");
          } else {
            that.submitForm("loginform");
          }
        }
      };
    },
    loginByphone: function (formName) {
      if (!this.isConfirm) {
        this.$message.error("请同意服务条款");
        return;
      }
      if (this.shake) {
        this.shake = false;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$http({
              url: "/master/user/loginByMobile",
              type: "post",
              params: {
                mobile: this.phoneLoginForm.phone,
                code: this.phoneLoginForm.code,
              },
            }).then((data)=> {
              if (data.data && data.data.resultStatus == 1) {
                this.shake = true;
                this.ammtVisible = true;
                return;
              } else if (data.data && data.data.resultStatus == 3) {
                this.shake = true;
                this.reason = data.data.reason;
                this.rzerrVisible = true;
                return;
              }
              // 跳转强制修改密码页面
              if (data.data.firstLogin == 1) {
                this.$refs.updatePwdModal.open();
              } else {
                this.loginSuccess(data.data.level);
              }
            }).catch(()=>{
              console.log(e)
              this.shake = true;
            });;
          } else {
            this.shake = true;
          }
        });
      }
    },
    getcode: function () {
      var that = this;
      var reg = /^1[1023456789]\d{9}$/;
      if (this.phoneLoginForm.phone) {
        if (reg.test(that.phoneLoginForm.phone)) {
          if (this.getcodeflage) {
            this.getcodeflage = false;
            this.sendCode(this.phoneLoginForm.phone);
            this.getcodetext = 120;
            this.timer = setInterval(function () {
              that.getcodetext--;
              if (that.getcodetext == 0) {
                that.getcodeflage = true;
                clearInterval(that.timer);
                that.getcodetext = "获取验证码";
              }
            }, 1000);
          }
        } else {
          this.$message.error("请输入正确的手机号");
        }
      } else {
        this.$message.error("请输入手机号");
      }
    },
    async sendCode(phone) {
      const signNumber = await this.$tools.phoneSignature();
      var that = this;
      this.$http({
        url: "/master/user/sendCode",
        type: "post",
        params: {
          mobile: phone,
          source: "login_register",
          signature: signNumber,
          isLogin:true,
        },
      }).then(function (data) {
        that.zqcode = data.data;
      }).catch(()=>{
        this.getcodeflage = true;
        clearInterval(this.timer);
        this.getcodetext = "获取验证码";
      });
    },
    //登录按钮点击事件
    submitForm: function (formName) {
      if (!this.isConfirm) {
        this.$message.error("请同意服务条款");
        return;
      }
      if (this.shake) {
        this.shake = false;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$http({
              url: "/master/user/login",
              type: "post",
              params: {
                account: this.ruleForm2.name,
                password: this.ruleForm2.pass,
                verifyCode: this.ruleForm2.loginCode,
                uuid: this.ruleCodeUuid,
              },
            }).then((data)=> {
              // if (that.radio) {
              //   that.$tools.setLocal("login", that.ruleForm2);
              // }
              if (data.data && data.data.resultStatus == 1) {
                this.shake = true;
                this.ammtVisible = true;
                return;
              } else if (data.data && data.data.resultStatus == 3) {
                this.shake = true;
                this.reason = data.data.reason;
                this.rzerrVisible = true;
                return;
              }
              // 跳转强制修改密码页面
              if (data.data.firstLogin == 1) {
                this.shake = true;
                this.$refs.updatePwdModal.open();
              } else {
                this.loginSuccess(data.data.level);
              }
            }).catch((e)=>{
              console.log(e)
              this.shake = true;
              this.ruleForm2.loginCode = "";
              this.getCode();
            });
          } else {
            this.shake = true;
            // this.$message.error("请输入正确的账号密码验证码");
          }
        });
      }
    },
    // 登录成功跳转
    loginSuccess(level) {
      this.$http({
        url: "/master/user/mechanPermission",
        type: "get",
        params: {
          version: this.$config.version,
        },
      }).then((data) => {
        const userinfo = data.mechanUser;
        delete data.mechanUser;
        delete data.httpCode;
        delete data.msg;
        delete data.timestamp;
        Object.assign(userinfo, data);
        this.$tools.setLocal("userinfo", userinfo, 1);
        this.$tools.setLocal("code", data.mechanCode, 1);
        localStorage.fxyfPcVueStorageVer = API_CONFIG.STORAGE_VER;
        this.$http({
          url: "/sys/dic/read/all",
          type: "get",
        }).then((data) => {
          this.$tools.setLocal("all", data.data);
          localStorage.localTime = new Date().getTime();
          let href = "/index_content";
          // if (level == 3) {
          //     href = "/index_content2";
          // }
          this.$router.push({
            path: href,
          });
        }).catch(e=>{
          console.log(e)
          this.shake = true;
        });;
      }).catch(e=>{
        console.log(e)
        this.shake = true;
      });
    },
    //切换选中状态
    // changeradio: function () {
    //   this.radio = !this.radio;
    // },
    goforget: function () {
      this.$router.push("/forget");
    },
    forget() {
      this.$refs.forget.forgetPwdShow = true;
    },
    link(url) {
      window.open(url);
    },
  },

  mounted() {},
};
</script>
<style lang="scss" scoped>
@import "~@/sass/pages/login";
</style>
